import React from 'react';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import { Pagination } from 'components';
import { Globals } from 'utils';
import { BannerService } from 'services';
import { AddIcon, DeleteIcon } from 'assets/icons';
import ModalCreateBanner from './modal-create-banner';
import { ModalDeleteBanner } from './modal-confirm';

const MODAL = {
  NONE: 0,
  CREATE: 1,
  DELETE: 2,
};

class Users extends React.Component {

  state = {
    modal: MODAL.NONE,
    selectedItem: null,
    data: [],
    pagination: {
      pages: 1,
      page: 1,
    },
  }

  componentDidMount(): void {
    this.getBanners();
  }

  getBanners = async (page = 1) => {
    try {
      const res = await BannerService.get({ page });
      const { data, ...rest } = res as any;
      this.setState({ data: data, pagination: rest });

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  setModal = (modal: number, item?: any) => {
    this.setState({ modal, selectedItem: item ?? null });
  }

  render() {

    const { modal } = this.state;

    return (
      <div id="banners">
        <Modal
          id="banners-create"
          show={modal === MODAL.CREATE}
          onHide={() => this.setModal(MODAL.NONE)}
        >
          <ModalCreateBanner
            banner={this.state.selectedItem}
            onClose={(reload) => {
              this.setModal(MODAL.NONE);
              if (reload) this.getBanners();
            }}
          />
        </Modal>

        <Modal
          id="banners-delete"
          show={modal === MODAL.DELETE}
          onHide={() => this.setModal(MODAL.NONE)}
        >
          <ModalDeleteBanner
            banner={this.state.selectedItem}
            onClose={(reload) => {
              this.setModal(MODAL.NONE);
              if (reload) this.getBanners();
            }}
          />
        </Modal>

        <header>
          <button onClick={() => this.setModal(MODAL.CREATE)}>
            <img src={AddIcon} alt="Nuevo" />
            <span>Nuevo</span>
          </button>
        </header>

        <main className="banners-list">
          <div className="head">
            <div>Imagen</div>
            <div>Tiempo</div>
            <div>Estatus</div>
            <div>Área</div>
            <div>Costo</div>
            <div />
          </div>

          {this.state.data.map((banner: any, index: number) => (
            <div className="item" key={index}>
              <div className="photo">
                <img src={Globals.fromPhotos(banner.photo)} alt="Imagen" />
              </div>
              <div>{ banner.time?.name }</div>
              <div>{ moment().isAfter(banner.expire_at) ? 'Vencido' : '' }</div>
              <div>{ banner.position?.name }</div>
              <div>{ Globals.formatMiles(banner.cost) }</div>
              <div className="actions">
                <img
                  src={DeleteIcon}
                  onClick={() => this.setModal(MODAL.DELETE, banner)}
                  title="Eliminar"
                  alt="Eliminar"
                />
              </div>
            </div>
          ))}

          {!this.state.data.length && (
            <p className="no-items">No se encontraron resultados</p>
          )}
        </main>

        <Pagination
          pages={this.state.pagination.pages}
          active={this.state.pagination.page}
          onChange={this.getBanners}
        />
      </div>
    )
  }
}

export default Users;